import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/provaantechlogo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import Service from './Navbar/ServiceNavbar';
import Eng from './Navbar/Eng';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [isMobileAboutOpen, setIsMobileAboutOpen] = useState(false);
  const aboutDropdownRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navigateHomeAndScroll = (section) => {
    setIsAboutDropdownOpen(false);
    if (isMenuOpen) setIsMenuOpen(false);

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        scrollToSection(section);
      }, 150);
    } else {
      scrollToSection(section);
    }
  };

  const scrollToSection = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (aboutDropdownRef.current && !aboutDropdownRef.current.contains(event.target)) {
        setIsAboutDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div style={{ fontSize: "16px", fontWeight: "500" }}>
      <nav className="relative z-50 py-2.5 shadow-lg bg-black/95 border-b border-gray-800 backdrop-blur-sm">
        <div className="max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center">
              <Link to="/">
                <div className="flex items-center">
                  <img src={logo} alt="Provaantech" style={{ maxWidth: '80px' }} />
                </div>
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="relative items-center hidden space-x-3 xl:space-x-5 lg:flex">
              {/* 1. Services Dropdown */}
              <Service />

              {/* 2. Case Studies */}
              <Link 
                to="/work" 
                className="px-2 py-2 text-white rounded-md font-normal text-base hover:text-cyan-400 transition-colors whitespace-nowrap"
              >
                Case Studies
              </Link>

              {/* 3. Products with IP / Platforms Badge */}
              <Link 
                to="/products" 
                className="px-2 py-2 text-white rounded-md font-normal text-base hover:text-cyan-400 transition-colors flex items-center gap-1.5 whitespace-nowrap"
              >
                <span>Products</span>
                <span className="px-1.5 py-0.5 text-[9px] font-bold bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded uppercase tracking-wider shadow-sm">
                  IP / Platforms
                </span>
              </Link>

              {/* 4. About Dropdown */}
              <div 
                className="relative"
                ref={aboutDropdownRef}
                onMouseEnter={() => setIsAboutDropdownOpen(true)}
                onMouseLeave={() => setIsAboutDropdownOpen(false)}
              >
                <div className="px-2 py-2 text-white rounded-md cursor-pointer select-none font-normal text-base hover:text-cyan-400 transition-colors flex items-center gap-1.5 whitespace-nowrap">
                  <span>About</span>
                  <FontAwesomeIcon icon={faAngleDown} className={`text-xs transition-transform duration-200 ${isAboutDropdownOpen ? 'rotate-180' : ''}`} />
                </div>

                {isAboutDropdownOpen && (
                  <div className="absolute pt-3 top-full left-0 min-w-[300px] z-50 animate-fadeIn">
                    <div className="bg-[#0b1120] border border-cyan-500/20 rounded-xl shadow-2xl p-3 backdrop-blur-md">
                      <div className="px-3 py-1.5 mb-1 text-[11px] font-semibold uppercase tracking-wider text-cyan-400 border-b border-gray-800/80">
                        Company & Delivery
                      </div>
                      <ul className="space-y-1 pt-1">
                        <li>
                          <a
                            onClick={() => navigateHomeAndScroll('about')}
                            className="cursor-pointer block p-2.5 rounded-lg hover:bg-white/5 transition-all group"
                          >
                            <div className="text-sm font-medium text-gray-100 group-hover:text-cyan-300 transition-colors">
                              Leadership & Engineering DNA
                            </div>
                            <div className="text-xs text-gray-400 line-clamp-1 mt-0.5 font-light">
                              Executive leadership and engineering culture
                            </div>
                          </a>
                        </li>
                        <li>
                          <Link
                            to="/services/solutions/business-transformation-advisory"
                            onClick={() => setIsAboutDropdownOpen(false)}
                            className="block p-2.5 rounded-lg hover:bg-white/5 transition-all group"
                          >
                            <div className="text-sm font-medium text-gray-100 group-hover:text-cyan-300 transition-colors">
                              Partner & White-Label Delivery
                            </div>
                            <div className="text-xs text-gray-400 line-clamp-1 mt-0.5 font-light">
                              Strategic partnerships & delivery capabilities
                            </div>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              {/* 5. Insights / Blog */}
              <Link 
                to="/insights" 
                className="px-2 py-2 text-white rounded-md font-normal text-base hover:text-cyan-400 transition-colors whitespace-nowrap"
              >
                Blog
              </Link>

              {/* 6. GCC */}
              <Link 
                to="/gcc" 
                className="px-2 py-2 text-white rounded-md font-normal text-base hover:text-cyan-400 transition-colors whitespace-nowrap"
              >
                GCC
              </Link>

              {/* 7. Careers */}
              <a 
                href={process.env.REACT_APP_CAREERS_URL || "https://provaantech.prohirey.com/careers/69c2222d902ece237543607c"} 
                className="px-2 py-2 text-white rounded-md font-normal text-base hover:text-cyan-400 transition-colors whitespace-nowrap"
              >
                Careers
              </a>

              {/* 8. Contact Button */}
              <button 
                onClick={() => navigateHomeAndScroll('contact')} 
                className="px-4 py-1.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-medium text-sm rounded-full transition-all shadow-md hover:shadow-cyan-500/20 whitespace-nowrap"
              >
                Contact
              </button>

              {/* 9. Book a Discovery Call */}
              <Link to="/book-demo" className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg font-medium text-sm hover:bg-blue-700 transition-colors shadow-md whitespace-nowrap">
                Book a Discovery Call
              </Link>

              {/* 10. Language Dropdown */}
              <Eng />
            </div>

            {/* Mobile Menu Button */}
            <div className="flex items-center lg:hidden">
              <button onClick={toggleMenu} className="p-2 text-white focus:outline-none">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Drawer Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-black/98 border-t border-gray-800 px-4 py-4 space-y-2">
            <Service toggleMenu={toggleMenu} />

            <Link 
              to="/work" 
              onClick={toggleMenu} 
              className="block px-3 py-2 text-white text-sm rounded-md hover:bg-neutral-800"
            >
              Case Studies
            </Link>

            <Link 
              to="/products" 
              onClick={toggleMenu} 
              className="flex items-center justify-between px-3 py-2 text-white text-sm rounded-md hover:bg-neutral-800"
            >
              <span>Products</span>
              <span className="px-1.5 py-0.5 text-[9px] font-bold bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded uppercase">
                IP / Platforms
              </span>
            </Link>

            {/* Mobile About Section */}
            <div>
              <div 
                onClick={() => setIsMobileAboutOpen(!isMobileAboutOpen)}
                className="flex items-center justify-between px-3 py-2 text-white text-sm rounded-md cursor-pointer hover:bg-neutral-800"
              >
                <span>About</span>
                <FontAwesomeIcon icon={faAngleDown} className={`text-xs transition-transform duration-200 ${isMobileAboutOpen ? 'rotate-180' : ''}`} />
              </div>
              {isMobileAboutOpen && (
                <div className="pl-4 py-1 space-y-1 bg-neutral-900 border-l-2 border-cyan-500 rounded-md my-1">
                  <a 
                    onClick={() => navigateHomeAndScroll('about')} 
                    className="block px-3 py-1.5 text-xs text-gray-200 hover:text-cyan-400"
                  >
                    Leadership & Engineering DNA
                  </a>
                  <Link 
                    to="/services/solutions/business-transformation-advisory" 
                    onClick={toggleMenu} 
                    className="block px-3 py-1.5 text-xs text-gray-200 hover:text-cyan-400"
                  >
                    Partner & White-Label Delivery
                  </Link>
                </div>
              )}
            </div>

            <Link 
              to="/insights" 
              onClick={toggleMenu} 
              className="block px-3 py-2 text-white text-sm rounded-md hover:bg-neutral-800"
            >
              Blog
            </Link>

            <Link 
              to="/gcc" 
              onClick={toggleMenu} 
              className="block px-3 py-2 text-white text-sm rounded-md hover:bg-neutral-800"
            >
              GCC
            </Link>

            <a 
              href={process.env.REACT_APP_CAREERS_URL || "https://provaantech.prohirey.com/careers/69463ca68ef6b3be1711a66a"} 
              onClick={toggleMenu} 
              className="block px-3 py-2 text-white text-sm rounded-md hover:bg-neutral-800"
            >
              Careers
            </a>

            <div className="pt-2 border-t border-gray-800 flex flex-col gap-2">
              <button 
                onClick={() => navigateHomeAndScroll('contact')} 
                className="w-full py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-sm font-medium rounded-md text-center"
              >
                Contact Us
              </button>
              <Link 
                to="/book-demo" 
                onClick={toggleMenu} 
                className="block w-full py-2 text-center text-sm text-white bg-blue-600 font-semibold rounded-md hover:bg-blue-700"
              >
                Book a Discovery Call
              </Link>
            </div>
            <div className="pt-2">
              <Eng toggleMenu={toggleMenu} />
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
